import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ApprovalUnifiedEventStepContent(props) {
  return /*#__PURE__*/_jsx(Text, {
    "data-test-id": "approval-unified-event-content",
    marginInlineStart: "400",
    textTransform: "none",
    typography: "body-100",
    textWrap: "wrap",
    children: props.children
  });
}